import { Result } from '../../shared/models/core/result.model';
import { User } from '../../shared/models/user.model';

export interface UserManagementState {
    userResult: Result<User> | null;
    selectedUser: User | null;
    error: any;
}

export const initialState: UserManagementState = {
    userResult: null,
    selectedUser: null,
    error: null
};
